import { useEffect } from 'react';
import dayjs from 'dayjs';
import updateLocale from 'dayjs/plugin/updateLocale';
import 'dayjs/locale/ru';
import 'dayjs/locale/es';
import 'dayjs/locale/fr';
import { useAppSelector } from 'store/hook';
import i18n from 'i18n';

dayjs.extend(updateLocale);
dayjs.updateLocale('ru', { weekStart: 0 });
dayjs.updateLocale('es', { weekStart: 0 });
dayjs.updateLocale('fr', { weekStart: 0 });

export const useLanguageSync = (): void => {
  const language = useAppSelector((state) => state.languageReducer.language);

  useEffect(() => {
    if (i18n.language !== language) {
      void i18n.changeLanguage(language);
    }
    dayjs.locale(language);
  }, [language]);
};
